import SearchIcon from '@mui/icons-material/Search';
import { useEditorRef } from 'platejs/react';
import toolbarStyles from '../PlateToolbar/PlateToolbar.module.scss';

// The FindReplacePanel lives inside PlateEditor (it owns the imperative ref).
// It registers its toggle on the OWNING editor instance as
// `editor.__findReplaceToggle` (see FindReplacePanel). This button renders
// inside the same editor's Plate context, so `useEditorRef()` resolves to that
// same editor — calling its toggle opens ONLY this editor's panel. A
// document-global event would instead fan out to every co-mounted editor.

interface FindReplaceButtonProps {
    className?: string;
}

export function FindReplaceButton({ className }: FindReplaceButtonProps) {
    const editor = useEditorRef() as any;

    const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault();
        editor.__findReplaceToggle?.();
    };

    return (
        <button
            type="button"
            data-find-replace-trigger
            className={className ?? toolbarStyles.btn}
            onMouseDown={handleMouseDown}
            title="Find and replace (⌘F / Ctrl+F)"
            aria-label="Find and replace"
            aria-keyshortcuts="Meta+F Control+F"
        >
            <SearchIcon fontSize="small" />
        </button>
    );
}
